import { useMemo } from "react";
import { useTranslation } from "react-i18next";
import { ReportingCycleEnum } from "../api/models/reportingCycle.models";

export const useCycleItems = () => {
  const { t } = useTranslation();

  const options = [
    { name: t("label-yearly"), value: ReportingCycleEnum.YEARLY },
    { name: t("label-quarterly"), value: ReportingCycleEnum.QUARTERLY },
    { name: t("label-monthly"), value: ReportingCycleEnum.MONTHLY },
  ];
  return options;
};
